/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputFAQ
 */
export interface InputFAQ {
    /**
     * 
     * @type {string}
     * @memberof InputFAQ
     */
    blockType?: string;
    /**
     * 
     * @type {number}
     * @memberof InputFAQ
     */
    priority?: number;
    /**
     * 
     * @type {string}
     * @memberof InputFAQ
     */
    section?: string;
    /**
     * 
     * @type {string}
     * @memberof InputFAQ
     */
    text?: string;
    /**
     * 
     * @type {string}
     * @memberof InputFAQ
     */
    title?: string;
}

/**
 * Check if a given object implements the InputFAQ interface.
 */
export function instanceOfInputFAQ(value: object): boolean {
    return true;
}

export function InputFAQFromJSON(json: any): InputFAQ {
    return InputFAQFromJSONTyped(json, false);
}

export function InputFAQFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputFAQ {
    if (json == null) {
        return json;
    }
    return {
        
        'blockType': json['blockType'] == null ? undefined : json['blockType'],
        'priority': json['priority'] == null ? undefined : json['priority'],
        'section': json['section'] == null ? undefined : json['section'],
        'text': json['text'] == null ? undefined : json['text'],
        'title': json['title'] == null ? undefined : json['title'],
    };
}

export function InputFAQToJSON(value?: InputFAQ | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'blockType': value['blockType'],
        'priority': value['priority'],
        'section': value['section'],
        'text': value['text'],
        'title': value['title'],
    };
}

